import { useState } from "react";
import { phoneDigits } from "../../utils/phoneFormat";
import PhoneInput from "./PhoneInput";

const inputClass = "mt-1.5 w-full rounded-xl border border-slate-200 bg-white px-4 py-2.5 text-sm outline-none transition focus:border-emerald-500 focus:ring-2 focus:ring-emerald-100";
const passwordBytes = (value) => encodeURIComponent(String(value || ""))
    .replace(/%[0-9A-F]{2}/gi, "x").length;

export default function EmployeeErpAccountForm({ employee, onClose, onSubmit, isLoading = false }) {
    const [form, setForm] = useState({
        email: employee?.email || "",
        phone_number: employee?.phone_number || "",
        telegram_username: employee?.telegram_username || "",
        role: "dev",
        password: "",
    });
    const [error, setError] = useState("");
    const setField = (key, value) => setForm((current) => ({ ...current, [key]: value }));

    const submit = async (event) => {
        event.preventDefault();
        setError("");
        const email = form.email.trim().toLowerCase();
        const phone = form.phone_number.trim();
        if (!email || !email.includes("@")) {
            setError("Укажите корректный email — он будет логином ERP.");
            return;
        }
        if (phone && !phoneDigits(phone)) {
            setError("Телефон должен быть российским номером: +7 900 000-00-00.");
            return;
        }
        if (passwordBytes(form.password) > 72) {
            setError("Пароль ERP не должен превышать 72 байта.");
            return;
        }
        try {
            await onSubmit({
                email,
                phone_number: phone ? `+${phoneDigits(phone)}` : null,
                telegram_username: form.telegram_username.trim() || null,
                role: form.role,
                password: form.password || null,
            });
        } catch (submitError) {
            setError(submitError?.message || String(submitError));
        }
    };

    return <div className="fixed inset-0 z-50 flex items-center justify-center bg-slate-950/60 p-4 backdrop-blur-sm" onClick={onClose} data-testid="employee-erp-account-overlay">
        <form className="w-full max-w-2xl rounded-3xl bg-white p-6 shadow-2xl md:p-8" onSubmit={submit} onClick={(event) => event.stopPropagation()} data-testid="employee-erp-account-form">
            <div className="flex items-start justify-between gap-4">
                <div><p className="text-xs font-bold uppercase tracking-[0.18em] text-emerald-600">Интеграция с ERP</p><h2 className="mt-2 text-2xl font-bold text-slate-900">Создать учётную запись</h2><p className="mt-1 text-sm text-slate-500">Для {employee?.full_name}. После создания карточки свяжутся автоматически.</p></div>
                <button type="button" onClick={onClose} className="text-2xl leading-none text-slate-400 hover:text-slate-700" aria-label="Закрыть">×</button>
            </div>
            <div className="mt-6 grid gap-4 sm:grid-cols-2">
                <label className="text-sm font-semibold text-slate-700">Email / логин ERP *<input type="email" required value={form.email} onChange={(event) => setField("email", event.target.value)} className={inputClass} data-testid="erp-account-email" /></label>
                <label className="text-sm font-semibold text-slate-700">Телефон<PhoneInput value={form.phone_number} onChange={(value) => setField("phone_number", value)} className={inputClass} data-testid="erp-account-phone" /></label>
                <label className="text-sm font-semibold text-slate-700">Telegram<input value={form.telegram_username} onChange={(event) => setField("telegram_username", event.target.value)} placeholder="@username" className={inputClass} data-testid="erp-account-telegram" /></label>
                <label className="text-sm font-semibold text-slate-700">Роль ERP<select value={form.role} onChange={(event) => setField("role", event.target.value)} className={inputClass} data-testid="erp-account-role"><option value="dev">Сотрудник</option><option value="manager">Менеджер</option><option value="leader">Руководитель</option><option value="dept_leader">Руководитель отдела</option><option value="hr">HR</option></select></label>
                <label className="text-sm font-semibold text-slate-700 sm:col-span-2">Пароль <span className="font-normal text-slate-400">(необязательно)</span><input type="password" value={form.password} onChange={(event) => setField("password", event.target.value)} placeholder="Оставьте пустым — ERP сгенерирует пароль" className={inputClass} data-testid="erp-account-password" /><span className={`mt-1 block text-xs font-normal ${passwordBytes(form.password) > 72 ? "font-semibold text-red-600" : "text-slate-400"}`}>{passwordBytes(form.password)}/72 байт</span></label>
            </div>
            {error ? <p className="mt-4 rounded-xl bg-red-50 px-4 py-3 text-sm font-medium text-red-700" role="alert">{error}</p> : null}
            <div className="mt-6 flex justify-end gap-3"><button type="button" onClick={onClose} className="rounded-xl border border-slate-200 px-4 py-2.5 text-sm font-semibold text-slate-600">Отмена</button><button type="submit" disabled={isLoading} className="rounded-xl bg-emerald-600 px-5 py-2.5 text-sm font-bold text-white hover:bg-emerald-500 disabled:opacity-50" data-testid="submit-erp-account">{isLoading ? "Создание…" : "Создать и связать"}</button></div>
        </form>
    </div>;
}
